/** Tipo de movimiento de honorario pendiente (get_pending_financer_honorarium_details). */
export enum EHonorariumMovementType {
    /** Valor de la prestación, con la fecha de la orden. */
    ORDER = 1,
    /** Débito o crédito. */
    ADJUSTMENT = 2,
    /** NC, condonación o anulación de cupón. Resta: su monto es negativo. */
    CANCELLATION = 3,
}

export const getHonorariumMovementTypeDescription = (type: number | null | undefined): string => {
    switch (type) {
        case EHonorariumMovementType.ORDER:
            return 'Orden';
        case EHonorariumMovementType.ADJUSTMENT:
            return 'Ajuste';
        case EHonorariumMovementType.CANCELLATION:
            return 'Anulación';
        default:
            return '—';
    }
};
